<script>
import Button from './Button.vue';
export default {
    components: { Button },
    props: {
        customFloatClasses: {
            type: String,
            default: ""
        },
        isShowMoreOption: {
            type: Boolean,
            required: true
        },
        userTypeAbbr: {
            type: String,
            required: true
        },
        isShowActionButton: {
            type: Boolean,
            required: true
        },
        showOptionsButton: {
            type: Function,
            required: true
        },
        allMoreOptions: {
            type: Array,
            required: true
        }

    }
};
</script>
<template>
    <div class="d-flex flex-column gap-2 align-items-center" :class="customFloatClasses ? customFloatClasses : 'customFloat my-2'">
        <div class="d-flex flex-column gap-2 align-items-center" v-if="isShowMoreOption">
                <Button
                    v-for="(option, index) in allMoreOptions"
                    :key="index"
                    variant="primary"
                    :onClick="() => option.onClickMethod(userTypeAbbr)"
                    type="button"
                    :title="option.title"
                    :classes="[`text-center btn rounded-circle customOptionSize fs-4 ${option.bgcolor}`, {'zoomInEffect': isShowMoreOption}]"
                >
                    <i :class="option.iconClass"></i>
                </Button>
        </div>
        <Button
            variant="primary"
            :onClick="() => showOptionsButton()"
            type="button"
            title="More"
            :classes="['text-center btn btn-primary rounded-circle customSize fs-3', {'zoomInEffect': isShowActionButton}]"
        >
            <i :class="isShowMoreOption ? 'bx bx-x' : 'bx bx-plus'"></i>
        </Button>
    </div>
</template>

<style scoped>
.customFloat{
	position:fixed;
	width:fit-content;
	height:fit-content;
	bottom:30px;
	right:30px;
}

.customSize {
    width: 70px;
    height: 70px;
}

.customOptionSize {
    width: 50px;
    height: 50px;
}

.zoomInEffect {
    opacity: 1;
    animation: zoominanimation ease-in-out 0.5s;
}
@keyframes zoominanimation {
    0% {
        opacity: 0;
        scale: 0;
    }
    100% {
        opacity: 1;
        scale: 1;
    }
}
</style>